import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardImagingWorkListUX = (props: any) => {
    return(
      <div
        id="CardImagingWorkListUX-div-0"
        style={{width:"100%", padding: "10px",  height: "100%"}}>
        <div
          className="ui form"
          id="CardImagingWorkListUX-div-1">
          
          <FormGroup
            id="CardImagingWorkListUX-FormGroup-2"
            style={{marginBottom: "0.5rem"}}>
            <FormField
              id="CardImagingWorkListUX-FormField-3"
              width={4}>
              <div
                id="CardImagingWorkListUX-div-13">
                {props.languageUX === "en" ? "Order department" : "แผนกที่สั่ง"}
              </div>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardImagingWorkList-Dropdown-OrderDepartment"
                name="division"
                onChange={props.onChangeValue}
                options={props.divisionOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.division || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-4"
              width={4}>
              <div
                id="CardImagingWorkListUX-div-14">
                {props.languageUX === "en" ? "Type" : "ประเภท"}
              </div>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardImagingWorkList-Dropdown-Type"
                name="xray_group"
                onChange={props.onChangeValue}
                options={props.imagingTestGroupOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.xray_group || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-5"
              width={4}>
              <div
                id="CardImagingWorkListUX-div-15">
                {props.languageUX === "en" ? "Radiologist" : "รังสีแพทย์"}
              </div>
              <div
                id="CardImagingWorkListUX-div-33"
                style={{width: "100%"}}>
                {props.SearchBoxRadiologist}
              </div>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-6"
              width={3}>
              <div
                id="CardImagingWorkListUX-div-16">
                {props.languageUX === "en" ? "Item status" : "สถานะรายการ"}
              </div>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardImagingWorkList-Dropdown-ItemStatus"
                name="orderStatus"
                onChange={props.onChangeValue}
                options={props.orderStatusOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.orderStatus || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-7"
              width={3}>
              <div
                id="CardImagingWorkListUX-div-17">
                {props.languageUX === "en" ? "Billing status" : "สถานะการเรียกเก็บเงิน"}
              </div>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardImagingWorkList-Dropdown-BillingStatus"
                name="billingStatus"
                onChange={props.onChangeValue}
                options={props.billingStatusOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.billingStatus || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-8"
              width={2}>
              <div
                id="CardImagingWorkListUX-div-18">
                {props.languageUX === "en" ? "Encounter type" : "ประเภท Encounter"}
              </div>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardImagingWorkList-Dropdown-EncounterType"
                name="encounterType"
                onChange={props.onChangeValue}
                options={props.encounterTypeOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.encounterType || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-9">
              <div
                id="CardImagingWorkListUX-div-26">
                {"\u00a0"}
              </div>
              <div
                id="CardImagingWorkListUX-div-60">
                {props.ButtonSearch}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardImagingWorkListUX-FormGroup-35">
            <FormField
              id="CardImagingWorkListUX-FormField-36"
              width={3}>
              <div
                id="CardImagingWorkListUX-div-44">
                {props.languageUX === "en" ? "Patient" : "ผู้ป่วย"}
              </div>
              <div
                id="CardImagingWorkListUX-div-49"
                style={{width: "100%"}}>
                {props.SearchBoxPatient}
              </div>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-37"
              width={3}>
              <div
                id="CardImagingWorkListUX-div-45">
                {props.languageUX === "en" ? "Order No." : "เลขที่ order"}
              </div>
              <div
                id="CardImagingWorkListUX-div-50"
                style={{width: "100%"}}>
                {props.SearchBoxOrderNo}
              </div>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-38">
              <div
                id="CardImagingWorkListUX-div-46">
                {props.languageUX === "en" ? "Order date" : "วันที่สั่ง"}
              </div>
              <DateTextBox
                id="CardImagingWorkList-DateTextBox-OrderStartDate"
                onChange={props.onChangeDate?.("startDate")}
                value={props.filter?.startDate || ""}>
              </DateTextBox>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-39">
              <div
                id="CardImagingWorkListUX-div-47">
                {"\u00a0"}
              </div>
              <div
                id="CardImagingWorkListUX-div-48"
                style={{marginTop: "0.5rem"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </div>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-40">
              <div
                id="CardImagingWorkListUX-div-53">
                {"\u00a0"}
              </div>
              <DateTextBox
                id="CardImagingWorkList-DateTextBox-OrderEndDate"
                onChange={props.onChangeDate?.("endDate")}
                value={props.filter?.endDate || ""}>
              </DateTextBox>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-41"
              style={{flex: 1}}>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-42">
              <div
                id="CardImagingWorkListUX-div-59">
                {"\u00a0"}
              </div>
              <div
                id="CardImagingWorkListUX-div-54"
                style={{marginRight: "0.5rem"}}>
                {props.IconRegister}
              </div>
            </FormField>
            <FormField
              id="CardImagingWorkListUX-FormField-43">
              <div
                id="CardImagingWorkListUX-div-58">
                {"\u00a0"}
              </div>
              <div
                id="CardImagingWorkListUX-div-55"
                style={{marginRight: "1.5rem"}}>
                {props.IconExecute}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardImagingWorkListUX-div-56"
          style={{marginTop: "1rem"}}>
          
          <Table
            data={props.orderList || []}
            getTdProps={props.onGetTdProps}
            headers={props.headers ? props.headers : "Orderdate/Time,Order No.,Patient,Order department,Careprovider,Type,Request,Status,Radiologist,"}
            id="CardImagingWorkListUX-Table-57"
            keys="check,datetime,order_no,patient,division_name,doctor_name,type,request,status,radiologist,action"
            minRows={7}
            resizable={false}
            showPagination={false}
            style={{height: "calc(100vh - 22rem)"}}
            widths="45,110,120,^155,^155,^140,^110,^155,^145,^155,^135">
          </Table>
        </div>
        <div
          id="CardImagingWorkListUX-div-61"
          style={{display: "flex", justifyContent: "flex-end", marginTop: "1rem"}}>
          {props.Pagination}
        </div>
      </div>
    )
}

CardImagingWorkListUX.displayName = "CardImagingWorkListUX";
export default React.memo(CardImagingWorkListUX)

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"10px\",  height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-3"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-4"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-5"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-6"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-7"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-8"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกที่สั่ง",
          "valueEN": "Order department"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-13"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท",
          "valueEN": "Type"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "รังสีแพทย์",
          "valueEN": "Radiologist"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะรายการ",
          "valueEN": "Item status"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการเรียกเก็บเงิน",
          "valueEN": "Billing status"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท Encounter",
          "valueEN": "Encounter type"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-26"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Dropdown",
      "parent": 3,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkList-Dropdown-OrderDepartment"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.division || \"\""
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Dropdown",
      "parent": 4,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkList-Dropdown-Type"
        },
        "name": {
          "type": "value",
          "value": "xray_group"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.imagingTestGroupOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.xray_group || \"\""
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Dropdown",
      "parent": 7,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkList-Dropdown-BillingStatus"
        },
        "name": {
          "type": "value",
          "value": "billingStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.billingStatusOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.billingStatus || \"\""
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Dropdown",
      "parent": 8,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkList-Dropdown-EncounterType"
        },
        "name": {
          "type": "value",
          "value": "encounterType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.encounterTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.encounterType || \"\""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxRadiologist"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Dropdown",
      "parent": 6,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkList-Dropdown-ItemStatus"
        },
        "name": {
          "type": "value",
          "value": "orderStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.orderStatusOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.orderStatus || \"\""
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormGroup-35"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-36"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-38"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-39"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-40"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-41"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-42"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-FormField-43"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วย",
          "valueEN": "Patient"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-44"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ order",
          "valueEN": "Order No."
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-45"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สั่ง",
          "valueEN": "Order date"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-46"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 39,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-47"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0.5rem\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxPatient"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxOrderNo"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-50"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 51,
      "name": "DateTextBox",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkList-DateTextBox-OrderStartDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate?.(\"startDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.startDate || \"\""
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 52,
      "name": "DateTextBox",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardImagingWorkList-DateTextBox-OrderEndDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate?.(\"endDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.endDate || \"\""
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-53"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.IconRegister"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "props.IconExecute"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"1.5rem\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 57,
      "name": "Table",
      "parent": 56,
      "props": {
        "data": {
          "type": "code",
          "value": "props.orderList || []"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.onGetTdProps"
        },
        "headers": {
          "type": "code",
          "value": "props.headers ? props.headers : \"Orderdate/Time,Order No.,Patient,Order department,Careprovider,Type,Request,Status,Radiologist,\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-Table-57"
        },
        "keys": {
          "type": "value",
          "value": "check,datetime,order_no,patient,division_name,doctor_name,type,request,status,radiologist,action"
        },
        "minRows": {
          "type": "code",
          "value": "7"
        },
        "resizable": {
          "type": "code",
          "value": "false"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100vh - 22rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "45,110,120,^155,^155,^140,^110,^155,^145,^155,^135"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-58"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-59"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-60"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.Pagination"
        },
        "id": {
          "type": "value",
          "value": "CardImagingWorkListUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", marginTop: \"1rem\"}"
        }
      },
      "seq": 61,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": true,
  "name": "CardImagingWorkListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
